import {
    EventrDate,
    SERPRegionRequestDtoSortByPref,
    SPSearchResp,
} from '@eventr/common'
import { EventrGatewayAPI } from '../../data/gateway.api'
import { TFiltersObj, THotelRoom } from './booking.interfaces'

export const getDateRangeFromEvent = (selectedEventInfo: any) => {
    const endDate = selectedEventInfo?.end_date
    const startDate = selectedEventInfo?.start_date
    if (endDate && startDate) {
        const start = new EventrDate(startDate)
        const end = new EventrDate(endDate)

        const dayDiff = end.userLocalLuxon.diff(
            start.userLocalLuxon,
            'days'
        ).days

        if (dayDiff > 0 && dayDiff <= 30) {
            return [start.clearTimezone(), end.clearTimezone()]
        } else {
            const onePlusDay = start.getCloneEventrDate()
            onePlusDay.add({ days: 1 })
            return [start.clearTimezone(), onePlusDay]
        }
    }
    return null
}

function getStarRatingsList(selected?: number) {
    if (!selected) {
        return []
    }

    const starList = []
    for (var i = 0; i < selected; i++) starList.push(i + 1)
    return starList
}

export async function getHotelsSearchData(
    checkIn: string,
    checkOut: string,
    rooms: THotelRoom[],
    page: number,
    sortByPreference: SERPRegionRequestDtoSortByPref,
    filtersObj: TFiltersObj,
    regionId: number,
    point: [number, number]
): Promise<SPSearchResp> {
    try {
        const resp = await EventrGatewayAPI.booking.hotel.SERPregion({
            check_in: checkIn,
            check_out: checkOut,
            region_id: regionId,
            point: point,
            per_page: 10,
            guests: rooms,
            page: page,
            sort_by: sortByPreference,

            currency: filtersObj.currency,
            price_range: filtersObj.priceRange,
            star_rating: getStarRatingsList(filtersObj.starRating),
            user_rating_range: filtersObj.userRatingRange,
        })

        if (resp.status === 'success' && resp.data) {
            return resp.data
        } else {
            return { totalHotels: 0, hotels: [] }
        }
    } catch {
        return { totalHotels: 0, hotels: [] }
    }
}
